import React from 'react';
import { motion } from 'framer-motion';
export function EmpathySection() {
  return <section className="py-8 md:py-12 px-4 md:px-6" style={{
    backgroundColor: 'var(--bg-surface)'
  }} data-id="element-179">
      <div className="max-w-[680px] mx-auto" data-id="element-180">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="space-y-3 md:space-y-5" data-id="element-181">
          <h2 className="text-xl md:text-3xl font-serif text-[var(--text-heading)] text-center" data-id="element-182">
            ¿Alguna vez has sentido que tus oraciones golpean el techo y
            rebotan?
          </h2>

          <div className="space-y-3 md:space-y-4 text-base md:text-lg text-[var(--text-primary)] leading-relaxed font-light" data-id="element-183">
            <p data-id="element-184">¿Que el silencio de Dios es tan pesado que duele?</p>
            <div className="bg-[var(--bg-card)] p-4 md:p-6 rounded-lg border border-[var(--accent)]/15" data-id="element-185">
              <p className="text-lg md:text-xl font-serif text-[var(--accent)] text-center italic" data-id="element-186">
                No estás aquí por accidente. Estás aquí porque el "Plan A"
                falló, las estructuras que te daban seguridad se derrumbaron y
                hoy, el desierto es tu única realidad.
              </p>
            </div>
            <p data-id="element-187">
              Sé lo que es levantarse con un nudo en la garganta. Sé lo que es
              fingir una sonrisa en la iglesia o frente a tu familia cuando, por
              dentro, sientes que Dios se olvidó de tu dirección.
            </p>
            <p data-id="element-188">
              La mayoría de los libros te dicen que "tengas más fe". Pero, ¿cómo
              tienes fe cuando no tienes fuerzas ni para levantarte de la cama?
            </p>
            <div className="border-l-2 border-[var(--accent)] pl-4 md:pl-5 py-1 my-1" data-id="element-189">
              <p className="font-serif italic text-[var(--text-heading)] text-base md:text-lg" data-id="element-190">
                "El error de muchos es intentar 'arreglar' el dolor antes de
                entenderlo. Intentan saltarse el proceso del desierto, sin saber
                que es allí donde se forjan las almas más inquebrantables."
              </p>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}